export const numberFormatAsked = (number: number | null | undefined) => {
  if (number === null || number === undefined) {
    return '0,00'
  }

  if (Number.isInteger(number)) {
    return number
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
      .replace('.', ':')
      .replaceAll(',', '.')
      .replace(':', ',')
  }

  return number
    .toFixed(2)
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
    .replace('.', ':')
    .replaceAll(',', '.')
    .replace(':', ',')
}